import type {PropsWithChildren} from 'react';

import {Alert} from '@/modules/finkn/components/alert';
import {PortableText} from '@/modules/foundation/sanity/portable-text';

import type {InlineBannerFragment} from './query';

type Props = PropsWithChildren & {
	data: InlineBannerFragment;
};

export const InlineBannerContainer = ({data}: Props) => {
	return (
		<div className="my-8">
			<Alert title={data.title} severity={data.severity}>
				{data.description && data.description.length > 0 ? (
					<PortableText value={data.description} />
				) : null}
			</Alert>
		</div>
	);
};
